import { Routes } from "../../constants/Routes";
import { CreateContractDto } from "../../models/CreateContractDto";
import BaseController from "../sharedControllers/BaseController";

/**
 * @namespace akademika.akamont.pages.contractAdd
 */

export default class ContractAdd extends BaseController {
  route = Routes.CONTRACT_ADD;
  parentRoute = Routes.CONTRACT_LIST;

  public onRouteMatched(): void {
    this.fetchModel(
      "api/Contract/GetBusinessUnitOptions",
      "businessUnitOptions"
    );
  }

  public async onAddContract() {
    const requestData = this.getModelData<CreateContractDto>();
    await this.post("api/Contract/AddContract", {
      body: requestData,
    });

    this.navTo(Routes.CONTRACT_LIST);
  }
}
